import { Box, Table, Thead, Tbody, Tr, Th, Td } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

/** Guess unit from key suffix */
const unitOf = key =>
    key.endsWith("_g")   ? "g"   :
        key.endsWith("_mg")  ? "mg"  :
            key.endsWith("_mcg") ? "µg"  :
                key === "calories"   ? "kcal": "";

export default function NutrientTable({ micros, numDates = 1 }) {
    const { t } = useTranslation();
    const nf = new Intl.NumberFormat("en-US", { maximumFractionDigits: 1 });

    return (
        <Box overflowX="auto" mb={8}>
            <Table variant="striped" size="sm">
                <Thead>
                    <Tr>
                        <Th>{t("nutrientTable.columns.nutrient")}</Th>
                        <Th isNumeric>{t("nutrientTable.columns.value")}</Th>
                        <Th>{t("nutrientTable.columns.range")}</Th>
                    </Tr>
                </Thead>
                <Tbody>
                    {micros.map(({ name, value, dri }) => {
                        const unit = unitOf(name);
                        const avg  = value && numDates ? value / numDates : 0;
                        const displayVal = avg ? `${nf.format(avg)} ${unit}` : "—";

                        let rangeTxt = "—";
                        if (dri && dri.min !== undefined) {
                            rangeTxt =
                                dri.max !== undefined
                                    ? `${dri.min} – ${dri.max} ${unit}`
                                    : `≥ ${dri.min} ${unit}`;
                        }

                        return (
                            <Tr key={name}>
                                <Td>{t(`nutrients.${name}`, { defaultValue: name })}</Td>
                                <Td isNumeric color={
                                    dri && avg
                                        ? (dri.max && avg > dri.max) || (dri.min && avg < dri.min)
                                            ? "red.500"              // out of range
                                            : "green.500"            // inside range
                                        : undefined
                                }>
                                    {displayVal}
                                </Td>
                                <Td>{rangeTxt}</Td>
                            </Tr>
                        );
                    })}
                </Tbody>
            </Table>
        </Box>
    );
}